// extracted by mini-css-extract-plugin
module.exports = {"RippleEffect__Container":"RippleEffect_RippleEffect__Container__rxvVi","RippleEffect__Circle":"RippleEffect_RippleEffect__Circle__d0zqj","ripple":"RippleEffect_ripple__Rb0s6"};